/**
 * Labstep
 *
 * @module components/Layout/GlobalSearch
 * @desc Component to do global search
 */

import LayoutGlobalSearchContent from 'labstep-web/components/Layout/GlobalSearch/Content';
import { withAuthenticatedUserEntity } from 'labstep-web/containers/AuthenticatedUser';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { MediaQuery } from 'labstep-web/core/MediaQuery';
import { Size } from 'labstep-web/core/MediaQuery/types';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import { DATA_TEST_ID } from './contants';
import type { LayoutGlobalSearchProps } from './types';

export const LayoutGlobalSearch: React.FC<
  LayoutGlobalSearchProps
> = ({ location, authenticatedUserEntity }) =>
  authenticatedUserEntity.hasGroupNotDeleted ? (
    <MediaQuery size={Size.tablet_desktop}>
      <ModalDefault
        key={location.key}
        header="Global Search"
        size="large"
        viewComponent={({ toggleModal }): React.ReactElement => (
          <ActionComponent
            type="icon"
            elementProps={{
              color: 'blue',
              popup: { content: 'Global Search' },
            }}
            onClick={toggleModal}
            dataTestId={DATA_TEST_ID.action_component}
            icon="search"
          />
        )}
        content={<LayoutGlobalSearchContent />}
      />
    </MediaQuery>
  ) : null;

export default withAuthenticatedUserEntity(
  withRouter(LayoutGlobalSearch),
);
